import { AbstractStringProperty } from './AbstractStringProperty'

export class DeviceType extends AbstractStringProperty {
  KEY: string = 'deviceType'
}
